<template>
  <div class="subtitle">
    <h5><slot>Warning!! Insert subtitle here</slot></h5>
  </div>
</template>
<script>
export default {
  name: "Subtitle",
};
</script>
<style lang="sass" scoped>
@import "../../assets/css/variables.scss"
.subtitle
  background-color: $primary-color
  padding: 10px
  text-align: center
  h5
    color: white
    margin-bottom: 0px
    font-size: 1.1rem
</style>
